import React from 'react';

var Basket = function Basket(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M6.006 10.03a1.003 1.003 0 0 0-.988 1.167l1.183 7c.08.48.498.833.987.833h9.624c.489 0 .907-.352.988-.833l1.183-7a.998.998 0 0 0-.988-1.167H6.005zm3.444-2h5.07l-1.463-3.658a1 1 0 0 1 1.857-.743l1.76 4.401h1.321a3.003 3.003 0 0 1 2.963 3.5l-1.183 7a3.004 3.004 0 0 1-2.963 2.5H7.188a3.004 3.004 0 0 1-2.963-2.5l-1.183-7a3 3 0 0 1 2.964-3.5h1.29l1.76-4.401a1 1 0 0 1 1.858.743L9.45 8.03z",
    fill: "currentColor",
    fillRule: "nonzero"
  }));
};

Basket.defaultProps = {
  role: "img",
  viewBox: "0 0 24 24"
};
import iconHandler from './hoc';
export { Basket as icon };
export default iconHandler(Basket);


//////////////////
// WEBPACK FOOTER
// ./~/@jsluna/icons/dist/Basket.js
// module id = 587
// module chunks = 0